
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */

// @ts-ignore 
import { Field, ImageField, FileField, LinkField, Item, TextField } from '@sitecore-content-sdk/nextjs';
// @ts-ignore 
import { ComponentProps } from 'src/lib/component-props';
// @ts-ignore 
import { RouteData } from '@sitecore-content-sdk/nextjs';
// @ts-ignore 
import { PageTypes as ProjectGMIPageTypes } from "src/.generated/Project.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBase } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Base as FoundationGMIBasePageFields } from "src/.generated/Foundation.GMI.model"
// @ts-ignore 
import { Project as ProjectGMIProjectGMI } from "src/.generated/Project.GMI.model"

export namespace PageTypes {

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/General Landing Page
    */
    export type GeneralLandingPage = FoundationGMIBase.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/General Landing Page as an Item
    */
    export type GeneralLandingPage_Item = Omit<Item, 'fields'> & GeneralLandingPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/General Landing Page as a Component
    */
    export type GeneralLandingPage_Component = ComponentProps & GeneralLandingPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/General Landing Page as a Route
    */
    export type GeneralLandingPage_Route = RouteData & GeneralLandingPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/PageTypes/General Landing Page
    */
    export type GeneralLandingPageJson = FoundationGMIBase.BasePageJson &  {
        

    }
}
export namespace Project.GMI {

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Site
    */
    export type HeadlessSite =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Site as an Item
    */
    export type HeadlessSite_Item = Omit<Item, 'fields'> & HeadlessSite

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Site as a Component
    */
    export type HeadlessSite_Component = ComponentProps & HeadlessSite

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Site as a Route
    */
    export type HeadlessSite_Route = RouteData & HeadlessSite

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Headless Site
    */
    export type HeadlessSiteJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Tenant
    */
    export type HeadlessTenant =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Tenant as an Item
    */
    export type HeadlessTenant_Item = Omit<Item, 'fields'> & HeadlessTenant

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Tenant as a Component
    */
    export type HeadlessTenant_Component = ComponentProps & HeadlessTenant

    /**
    * Represents the template /sitecore/templates/Project/GMI/Headless Tenant as a Route
    */
    export type HeadlessTenant_Route = RouteData & HeadlessTenant

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Headless Tenant
    */
    export type HeadlessTenantJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/JSS Settings
    */
    export type JssSettings =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/JSS Settings as an Item
    */
    export type JssSettings_Item = Omit<Item, 'fields'> & JssSettings

    /**
    * Represents the template /sitecore/templates/Project/GMI/JSS Settings as a Component
    */
    export type JssSettings_Component = ComponentProps & JssSettings

    /**
    * Represents the template /sitecore/templates/Project/GMI/JSS Settings as a Route
    */
    export type JssSettings_Route = RouteData & JssSettings

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/JSS Settings
    */
    export type JssSettingsJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Design Folder
    */
    export type PageDesignFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Design Folder as an Item
    */
    export type PageDesignFolder_Item = Omit<Item, 'fields'> & PageDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Design Folder as a Component
    */
    export type PageDesignFolder_Component = ComponentProps & PageDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Design Folder as a Route
    */
    export type PageDesignFolder_Route = RouteData & PageDesignFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Page Design Folder
    */
    export type PageDesignFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Designs
    */
    export type PageDesigns =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Designs as an Item
    */
    export type PageDesigns_Item = Omit<Item, 'fields'> & PageDesigns

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Designs as a Component
    */
    export type PageDesigns_Component = ComponentProps & PageDesigns

    /**
    * Represents the template /sitecore/templates/Project/GMI/Page Designs as a Route
    */
    export type PageDesigns_Route = RouteData & PageDesigns

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Page Designs
    */
    export type PageDesignsJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Design Folder
    */
    export type PartialDesignFolder =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Design Folder as an Item
    */
    export type PartialDesignFolder_Item = Omit<Item, 'fields'> & PartialDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Design Folder as a Component
    */
    export type PartialDesignFolder_Component = ComponentProps & PartialDesignFolder

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Design Folder as a Route
    */
    export type PartialDesignFolder_Route = RouteData & PartialDesignFolder

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Partial Design Folder
    */
    export type PartialDesignFolderJson =  {
        

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Designs
    */
    export type PartialDesigns =  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Designs as an Item
    */
    export type PartialDesigns_Item = Omit<Item, 'fields'> & PartialDesigns

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Designs as a Component
    */
    export type PartialDesigns_Component = ComponentProps & PartialDesigns

    /**
    * Represents the template /sitecore/templates/Project/GMI/Partial Designs as a Route
    */
    export type PartialDesigns_Route = RouteData & PartialDesigns

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/Partial Designs
    */
    export type PartialDesignsJson =  {
        

    }
}
export namespace PageTypes {

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Product Detail Page
    */
    export type ProductDetailPage = FoundationGMIBase.BasePage &  {
        fields?: { 
            /**
            * Represents the Facing Fields field (d14f7809-5de7-40d8-a1c7-d8b8106de89d).
            */
            facingFields?: Item[];

            /**
            * Represents the Hide Pear Commerce field (85e7480b-3b85-42de-840c-dfda46fd9f63).
            */
            hidePearCommerce?: Field<boolean>;

            /**
            * Represents the Product ID field (2256b0d6-3f67-4cc3-be07-cf3ab7c29efc).
            */
            productID?: Field<string>;

            /**
            * Represents the Third Party Product Data field (4d121fc4-ec01-4ba0-a1c5-1a55930f4c9d).
            */
            thirdPartyProductData?: Item;
        }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Product Detail Page as an Item
    */
    export type ProductDetailPage_Item = Omit<Item, 'fields'> & ProductDetailPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Product Detail Page as a Component
    */
    export type ProductDetailPage_Component = ComponentProps & ProductDetailPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Product Detail Page as a Route
    */
    export type ProductDetailPage_Route = RouteData & ProductDetailPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/PageTypes/Product Detail Page
    */
    export type ProductDetailPageJson = FoundationGMIBase.BasePageJson &  {
        
            /**
            * Represents the Facing Fields field (d14f7809-5de7-40d8-a1c7-d8b8106de89d).
            */
            facingFields?: {
                jsonValue: Item[]
            };

            /**
            * Represents the Hide Pear Commerce field (85e7480b-3b85-42de-840c-dfda46fd9f63).
            */
            hidePearCommerce?: {
                jsonValue: Field<boolean>
            };

            /**
            * Represents the Product ID field (2256b0d6-3f67-4cc3-be07-cf3ab7c29efc).
            */
            productID?: {
                jsonValue: Field<string>
            };

            /**
            * Represents the Third Party Product Data field (4d121fc4-ec01-4ba0-a1c5-1a55930f4c9d).
            */
            thirdPartyProductData?: {
                jsonValue: Item
            };


    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Recipe Wildcard Page
    */
    export type RecipeWildcardPage = FoundationGMIBase.BasePage &  {
        fields?: {         }

    }

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Recipe Wildcard Page as an Item
    */
    export type RecipeWildcardPage_Item = Omit<Item, 'fields'> & RecipeWildcardPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Recipe Wildcard Page as a Component
    */
    export type RecipeWildcardPage_Component = ComponentProps & RecipeWildcardPage

    /**
    * Represents the template /sitecore/templates/Project/GMI/PageTypes/Recipe Wildcard Page as a Route
    */
    export type RecipeWildcardPage_Route = RouteData & RecipeWildcardPage

    /**
    * Represents the GraphQL template /sitecore/templates/Project/GMI/PageTypes/Recipe Wildcard Page
    */
    export type RecipeWildcardPageJson = FoundationGMIBase.BasePageJson &  {
        

    }
}




/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export namespace PageTypes.Constants {

    export const GeneralLandingPage = {
        TemplateId: "00439d79-c90c-4ded-bf52-c4d0404bf7f3",
    
        BaseTemplateIds: [
            "33a35de8-5057-4992-b209-50e19fe0b5fa", 
            "4c8619a1-f7cf-422b-a201-a3438db386ae", 
            "115002cf-5dbb-4e02-a646-0bd5c8a935ee", 
            "9fbd583f-95dd-4db7-bd61-7dc6925d95c9", 
            "e1a343c6-72ef-4a58-8d25-97f18a4453e1", 
        ]
    }
}
export namespace Project.GMI.Constants {

    export const HeadlessSite = {
        TemplateId: "ac5c5911-839e-4130-8675-5d77b750cb58",
    
        BaseTemplateIds: [
        ]
    }
    export const HeadlessTenant = {
        TemplateId: "c3ad7833-764b-4de0-b42f-dafcdc6a93ef",
    
        BaseTemplateIds: [
        ]
    }
    export const JssSettings = {
        TemplateId: "6d778a82-f230-42f7-9ebb-0c25ebc4a6cc",
    
        BaseTemplateIds: [
        ]
    }
    export const PageDesignFolder = {
        TemplateId: "9c75cc3a-b79b-47e2-a801-40c6f7414c6f",
    
        BaseTemplateIds: [
        ]
    }
    export const PageDesigns = {
        TemplateId: "11d22431-f378-4a68-8ee5-ffc1ea5005cf",
    
        BaseTemplateIds: [
        ]
    }
    export const PartialDesignFolder = {
        TemplateId: "e2f40205-f385-4134-a57f-bab1f3850e2f",
    
        BaseTemplateIds: [
        ]
    }
    export const PartialDesigns = {
        TemplateId: "f004e782-2325-407d-aa8f-f3195808f8ac",
    
        BaseTemplateIds: [
        ]
    }
}
export namespace PageTypes.Constants {

    export const ProductDetailPage = {
        TemplateId: "fe54b75b-3e0d-44dd-95dd-ce583d2b7a7a",
    
        BaseTemplateIds: [
            "33a35de8-5057-4992-b209-50e19fe0b5fa", 
            "4c8619a1-f7cf-422b-a201-a3438db386ae", 
            "115002cf-5dbb-4e02-a646-0bd5c8a935ee", 
            "9fbd583f-95dd-4db7-bd61-7dc6925d95c9", 
            "e1a343c6-72ef-4a58-8d25-97f18a4453e1", 
        ]
    }
    export const RecipeWildcardPage = {
        TemplateId: "25d500f5-e463-4d04-af40-d31142a4db8d",
    
        BaseTemplateIds: [
            "33a35de8-5057-4992-b209-50e19fe0b5fa", 
            "4c8619a1-f7cf-422b-a201-a3438db386ae", 
            "115002cf-5dbb-4e02-a646-0bd5c8a935ee", 
            "9fbd583f-95dd-4db7-bd61-7dc6925d95c9", 
            "e1a343c6-72ef-4a58-8d25-97f18a4453e1", 
        ]
    }
}    


